// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"InnerLoader_wrapper__1svnw","iconWrapper":"InnerLoader_iconWrapper__3Heeq","progress":"InnerLoader_progress__33uHX"};